export default __webpack_public_path__ + "static/media/SURVIVE_1.935dc48b.jpg";